import { ValidateAny } from "./ValidateAny";

export class ValidateBoolean<TRoot> extends ValidateAny<boolean, TRoot> {
    public requireTrue(message?: string) {
        this.isRequired = true;

        this.add((value: any) => {
            if (value === true)
                return null;

            return { message: message || 'Dit veld is verplicht' };
        });

        return this;
    }
}
